var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ext-box"},[_c('div',{staticClass:"int-box",style:({ 'text-align': _vm.left ? 'left' : 'right' })},[_c('span',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }